import React from 'react';
import PropTypes from 'prop-types';
import { Interactable, Hr, Icon, withConfirmationModal, ModalHeader } from 'LocalGluons';
import { ScrollView, View, ImageBackground } from 'react-native';

import NavigationService from 'NavigationService';
import { getInfoListItems } from 'Utils';
import { t } from 'Locale/index';
import AssetDetail from 'LocalGluons/components/AssetDetail';
import InfoList from 'LocalGluons/components/InfoList';
import { CONNECTION_TYPE, Device, getNetInfo, Orientation } from 'DeviceUtils';
import DetailModel from 'Pages/Details/models/DetailModel';
import DetailScene from 'Pages/Details/models/DetailScene';
import { withStore } from 'Store/index';

import { ConfirmationModal } from 'LocalGluons/components/ConfirmationModal';
import ButtonsContainer from 'Pages/Details/components/ButtonsContainer/ButtonsContainer';
import SeriesList from 'Pages/Details/SeriesList';
// import RecommendedMoviesCarousel from 'Pages/Details/components/RecommendedMoviesCarousel/RecommendedMoviesCarousel';
import { withItemUpdater } from 'Pages/Details/ItemUpdater';
import { useAppSelector } from 'ReduxStore/hooks';
import { connect } from 'react-redux';

import defaultStyles from './DetailsPopup.jss';
import {
    TOP_BAR_TOTAL_HEIGHT,
    MINIMISED_OFFSET
} from '../../../../../runtime/Navigation/Menu/Menu.styles';

class DetailsPopup extends React.Component {
    static getDerivedStateFromProps({ loading, item, mCoreConfig }) {
        const model = new DetailModel(item, undefined, mCoreConfig?.archiveSchedulesValidInMillis);

        return { loading, model };
    }

    constructor(props) {
        super(props);
        const { item, mCoreConfig, updateItem } = props;
        const model = new DetailModel(item, undefined, mCoreConfig?.archiveSchedulesValidInMillis);

        this.state = {
            loading: false,
            model
        };

        this.playerInitialized = false;

        this.scene = new DetailScene(model, updateItem);
    }

    componentDidMount() {
        // Ensure portrait lock when coming from player or epg
        if (Device.isPhone) {
            Orientation.lockToPortrait();
        }

        this.scene.setRefreshOnProgramEnd();
    }

    componentDidUpdate() {
        const { updateItem, playerData, item } = this.props;
        const { model } = this.state;

        if (playerData) {
            this.scene.removeRefreshOnProgramEnd();
        } else {
            this.scene.setRefreshOnProgramEnd();
        }

        // If player is closed and was opened from detail, update item for recordings data
        if (!playerData && this.playerInitialized) {
            this.playerInitialized = false;
            updateItem(item);
        }

        this.scene.updateData(model, updateItem);
    }

    componentWillUnmount() {
        const { playerData } = this.props;

        if (this.parent === 'TvGuide' && Device.isPhone && !playerData) {
            Orientation.unlockAllOrientations();
        }

        this.scene.removeRefreshOnProgramEnd();
    }

    onLoading = (loading) => {
        this.setState({ loading });
    };

    onTrailerPress = () => {
        this.onPlayPress(true);
    };

    onPlayPress = (isTrailer = false) => {
        const { model } = this.state;
        if (model.canBePlayed) {
            this.playContent({
                isTrailer
            });
        }
    };

    onWifiDialogConfirm = () => {
        const { navigation } = this.props;
        this.hideWifiDialog();
        navigation.navigate('NetworkSettings');
    };

    updateItem = () => {
        const { updateItem, item } = this.props;
        updateItem(item);
    };

    hideWifiDialog = () => {
        const { setModalContent } = this.props;
        setModalContent(null);
    };

    playContent = async (playerData = {}) => {
        const { model } = this.state;
        const newPlayerData = {
            ...playerData,
            item: playerData.item || model.itemToPlay
        };
        const { deviceStorageState, setPlayerData } = this.props;

        if (Device.isWeb) {
            setPlayerData(newPlayerData);
            this.playerInitialized = true;
            return;
        }

        try {
            const netInfo = await getNetInfo();

            if (
                netInfo.type === CONNECTION_TYPE.CELLULAR &&
                !deviceStorageState.videoStreamingOverCellular
            ) {
                const { setModalContent } = this.props;
                setModalContent(
                    <ConfirmationModal
                        header={`${t('COMMON.WIFI_ONLY_IS_SET')}`}
                        message={t('COMMON.WIFI_ONLY_PLAY_DESCRIPTION')}
                        confirmLabel={t('COMMON.OPEN_NETWORK_SETTINGS')}
                        cancelLabel={t('COMMON.BTN_CANCEL')}
                        onConfirm={this.onWifiDialogConfirm}
                        onCancel={this.hideWifiDialog}
                    />
                );
            } else {
                setPlayerData(newPlayerData);
                this.playerInitialized = true;
            }
        } catch (error) {
            console.log(error);
        }
    };

    render() {
        const { model } = this.state;
        const {
            seasons,
            episodes,
            parentItem,
            canBePlayed,
            hasRecommendedCarousel,
            item,
            isArchiveAvailable,
            isDownloadable,
            isArchive
        } = model;
        const {
            navigation,
            updateItem,
            deviceStorageState,
            setModalContent,
            onClose,
            isMinimised,
            isLowLatency
        } = this.props;
        const { loading } = this.state;
        const buttonsContainerProps = {
            style: defaultStyles.buttonsContainer,
            navigation,
            item,
            parentItem,
            isArchiveAvailable,
            isDownloadable,
            onTrailerPress: this.onTrailerPress,
            onLoading: this.onLoading,
            updateItem: this.updateItem,
            setModalContent
        };

        const topMargin =
            isMinimised && Device.isWeb
                ? TOP_BAR_TOTAL_HEIGHT - MINIMISED_OFFSET
                : TOP_BAR_TOTAL_HEIGHT;

        return (
            <View
                style={[
                    defaultStyles.container,
                    Device.isWeb
                        ? {
                              marginTop: topMargin,
                              transition: 'margin .16s linear'
                          }
                        : {}
                ]}
            >
                <>
                    <ModalHeader
                        style={{ iconContainer: defaultStyles.header }}
                        onPress={onClose}
                    />
                    {!loading && (
                        <ScrollView
                            contentContainerStyle={defaultStyles.container}
                            // onScroll={NavigationService.getTopBarHandler()}
                            scrollEventThrottle={NavigationService.DEFAULT_SCROLL_THROTTLE}
                        >
                            <View key="details-first-block" style={defaultStyles.firstBlock}>
                                <View style={defaultStyles.detailContainer}>
                                    <Interactable
                                        onPress={() => {
                                            if (canBePlayed && !(isLowLatency && isArchive)) {
                                                if (Device.isWeb) {
                                                    document
                                                        .querySelector('#videoPlayer')
                                                        ?.play?.();
                                                }
                                                this.playContent();
                                            }
                                        }}
                                    >
                                        <ImageBackground
                                            style={defaultStyles.previewImage}
                                            source={{ uri: model.getPreviewImage() }}
                                            // defaultSource={{ uri: model.getPreviewImage() }}
                                        >
                                            {canBePlayed && !(isLowLatency && isArchive) && (
                                                <Icon
                                                    style={defaultStyles.playButton}
                                                    name="play_arrow"
                                                />
                                            )}
                                        </ImageBackground>
                                    </Interactable>
                                </View>
                                <View style={defaultStyles.assetDetailConxtainer}>
                                    <AssetDetail
                                        style={defaultStyles.assetDetail}
                                        item={item}
                                        subtitleStyle={defaultStyles.subtitle}
                                        isDetailsPopupAndWeb={Device.isWeb}
                                    >
                                        <>
                                            <ButtonsContainer
                                                {...buttonsContainerProps}
                                                isLowLatency={isLowLatency}
                                            />
                                            <Hr />
                                        </>
                                    </AssetDetail>
                                    {seasons && (
                                        <SeriesList
                                            titlePrefix={t('COMMON.SEASON')}
                                            navigation={navigation}
                                            listData={seasons}
                                            parentItem={item}
                                            listHeader={t('COMMON.SEASONS')}
                                            onPlayPress={this.playContent}
                                        />
                                    )}
                                    {episodes && (
                                        <SeriesList
                                            titlePrefix={t('COMMON.EPISODE')}
                                            navigation={navigation}
                                            listData={episodes}
                                            parentItem={item}
                                            listHeader={t('COMMON.EPISODES')}
                                            onPlayPress={this.playContent}
                                        />
                                    )}
                                    <InfoList
                                        items={getInfoListItems(item, deviceStorageState.language)}
                                        isSingleColumn={Device.isTabletOrWeb}
                                    />
                                </View>
                            </View>
                            {/* <View key="details-second-block" style={defaultStyles.secondBlock}>
                                {hasRecommendedCarousel && (
                                    <RecommendedMoviesCarousel
                                        style={defaultStyles.recommendedCarousel}
                                        onMoviePress={updateItem}
                                        item={item}
                                    />
                                )}
                            </View> */}
                        </ScrollView>
                    )}
                </>
            </View>
        );
    }
}

DetailsPopup.defaultProps = {
    parentItem: null,
    loading: false
};

DetailsPopup.propTypes = {
    navigation: PropTypes.shape({
        state: PropTypes.shape({}),
        addListener: PropTypes.func.isRequired
    }).isRequired,
    item: PropTypes.shape({}).isRequired,
    parentItem: PropTypes.shape({}),
    loading: PropTypes.bool,
    appManager: PropTypes.shape({
        state: PropTypes.shape({})
    }).isRequired,
    setPlayerData: PropTypes.func.isRequired,
    deviceStorageState: PropTypes.shape({}).isRequired,
    setModalContent: PropTypes.func.isRequired,
    updateItem: PropTypes.func.isRequired,
    playerData: PropTypes.shape({}).isRequired,
    mCoreConfig: PropTypes.shape({}).isRequired,
    onClose: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
    isMinimised: state.webMenu.isMinimised
});

const DetailsWithDataStore = withStore(connect(mapStateToProps)(DetailsPopup));
const DetailsWithItemUpdater = withItemUpdater(DetailsWithDataStore, false, true);
const DetailsWithConfirmationModal = withConfirmationModal(DetailsWithItemUpdater);

export default DetailsWithConfirmationModal;
